/* #391: ページへのリンクに入っていない写真を、右クリック・長押し・ドラッグで保存しにくくする。 */
(function () {
  'use strict';

  // 文字の節が対象なら親の要素を見る。対象なしや document は写真として扱わない。
  function getElement(target) {
    if (!target) return null;
    return target.nodeType === 1 ? target : target.parentElement;
  }

  function isProtectedImage(element) {
    if (!element || typeof element.closest !== 'function') return false;
    if (!element.closest('img, picture, .pswp__img')) return false;
    // 別ページへのリンク操作は残す。商品ページの小さい写真は守る側に入れる。
    var link = element.closest('a[href]');
    return !link || link.hasAttribute('data-product-thumb');
  }

  // 写真以外の文字・リンク・ボタン・入力欄の右クリックはそのまま使える。
  document.addEventListener('contextmenu', function (event) {
    if (isProtectedImage(getElement(event.target))) event.preventDefault();
  }, true);

  // 守る写真だけドラッグを止め、リンクそのものはそのまま使える。
  document.addEventListener('dragstart', function (event) {
    if (isProtectedImage(getElement(event.target))) event.preventDefault();
  }, true);

  // 右クリックのメニューを止めると、PhotoSwipe に右ボタンを離す操作も届く。
  // 押し下げと離す操作がタップと数えられ、写真が拡大するため、押し下げだけ届けない。
  // 拡大表示の守る写真だけを対象にし、ブラウザの既定の動作はここでは止めない。
  document.addEventListener('pointerdown', function (event) {
    var element = getElement(event.target);
    if (event.button === 2 && isProtectedImage(element) && element.closest('.pswp')) {
      event.stopPropagation();
    }
  }, true);
})();
